export * from './IPartner';


// WEBPACK FOOTER //
// ./src/models/index.ts